import AOPFieldVisibilityToggle from "@/src/components/AdmissionsOfficePage/shared/AOPFieldVisibilityToggle/AOPFieldVisibilityToggle";
import { Control, Controller, Path, FieldValues } from "react-hook-form";

interface MaltaFullTimeFeeFieldProps<T extends FieldValues> {
  control: Control<T>;
  name: Path<T>;
  visibilityName?: Path<T>;
  /** Optional boolean flag toggle (e.g. letter "S" → tuition_fee_flag). */
  flagName?: Path<T>;
  flagLetter?: string;
  flagAriaLabel?: string;
  label: string;
  inputClassName: string;
  inputId: string;
  readOnly?: boolean;
  disabled?: boolean;
  hideVisibilityToggle?: boolean;
}

const MaltaFullTimeFeeField = <T extends FieldValues>({
  control,
  name,
  visibilityName,
  flagName,
  flagLetter = "S",
  flagAriaLabel,
  label,
  inputClassName,
  inputId,
  readOnly = false,
  disabled = false,
  hideVisibilityToggle = false,
}: MaltaFullTimeFeeFieldProps<T>) => {
  const showVisibility = !hideVisibilityToggle && !!visibilityName;
  const showFlag = !!flagName;
  const hasSideToggles = showVisibility || showFlag;

  return (
    <div
      className={`form-group-fields-input${hasSideToggles ? " has-visibility-toggle" : ""}${
        showVisibility && showFlag ? " has-two-letter-toggles" : ""
      }`}
    >
      <div className="form-group-fields-input-label">
        <label htmlFor={inputId}>{label}</label>
        <div className="form-group-fields-input-label-line"></div>
      </div>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <input
            className={inputClassName}
            id={inputId}
            type="text"
            {...field}
            value={field.value ?? ""}
            readOnly={readOnly}
            disabled={disabled}
          />
        )}
      />
      {hasSideToggles && (
        <div className="form-group-fields-input-svg">
          {showFlag && flagName && (
            <Controller
              name={flagName}
              control={control}
              render={({ field }) => (
                <AOPFieldVisibilityToggle
                  letter={flagLetter}
                  visible={!!field.value}
                  onChange={field.onChange}
                  ariaLabel={flagAriaLabel ?? `${label} ${flagLetter} flag`}
                  disabled={disabled}
                />
              )}
            />
          )}
          {showVisibility && visibilityName && (
            <Controller
              name={visibilityName}
              control={control}
              render={({ field }) => (
                <AOPFieldVisibilityToggle
                  visible={!!field.value}
                  onChange={field.onChange}
                  ariaLabel={`${label} visibility`}
                  disabled={disabled}
                />
              )}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default MaltaFullTimeFeeField;
